export { isTeamsAppEnabled } from '../src/isTeamsAppEnabled';
